import classNames from 'classnames'
import React, { useEffect } from 'react'
import { useFilterStore } from '../../state/filterStore'
import * as UI from '@brewlogix/blx-ui'
import { Checkbox } from '@chakra-ui/react'
import { PatronOption } from 'src/types/schema/graphql'
import { clearFilters, parseLabel } from '../../utils/functions'

const PatronOptions: React.FC = () => {
    const {
        setFilterCount,
        togglePatronArrowUp,
        setTogglePatronArrowUp,
        patronFilterOptions,
        setPatronFilterOptions,
    } = useFilterStore()

    // Use effect to update UI whenever a user clicks on the homepage option for a preset filter
    useEffect(() => {
        setFilterCount()
    }, [patronFilterOptions])

    const handleFilterSelection = (item: PatronOption) => {
        if (patronFilterOptions?.length) {
            if (!patronFilterOptions?.includes(item)) {
                setPatronFilterOptions([...patronFilterOptions, item])
            } else {
                setPatronFilterOptions(patronFilterOptions?.filter((brew) => brew !== item))
            }
        } else {
            setPatronFilterOptions([item])
        }
    }

    const patronOptionChoices = Object.values(PatronOption).map((item) => ({
        label: parseLabel(item),
        value: item,
    }))

    return (
        <div
            className={classNames(
                'flex flex-col items-start justify-start ',
                togglePatronArrowUp ? 'mb-6' : ''
            )}
        >
            <UI.Button
                label='Patron Options'
                data-cy='filterPatron'
                theme='link'
                customClasses='flex flex-row-reverse justify-start text-dark pb-0 pl-0'
                onClick={() => setTogglePatronArrowUp(!togglePatronArrowUp)}
                size='sm'
            >
                <UI.Icon
                    slug='HeroIcons.ChevronRight'
                    size='sm'
                    customClasses={classNames(
                        togglePatronArrowUp ? '-rotate-90' : '',
                        'text-gray-300 mr-2 pointer-events-none'
                    )}
                />
            </UI.Button>

            <div className={classNames(!togglePatronArrowUp ? 'hidden' : '', 'flex flex-col pl-1')}>
                {patronFilterOptions?.length ? (
                    <div className='ml-1 flex flex-col'>
                        <UI.Button
                            theme='link'
                            customClasses='pl-0 flex items-center font-thin'
                            size='sm'
                            onClick={() => {
                                clearFilters('patron')
                                setPatronFilterOptions([])
                                setFilterCount()
                            }}
                        >
                            <UI.Icon
                                slug='HeroIconsSolid.XCircle'
                                theme='link'
                                customClasses='mr-2'
                                size='sm'
                            />
                            Clear
                        </UI.Button>
                    </div>
                ) : (
                    ''
                )}
                {patronOptionChoices.map((item, index) => (
                    <div key={`filterOption-${item.label}`} className='flex flex-col'>
                        <Checkbox
                            className='patron-filter pt-2'
                            id={`filterPatron-${item.label}-${index}`}
                            onChange={() => handleFilterSelection(item?.value)}
                            isChecked={
                                item.value ? patronFilterOptions.includes(item.value) : false
                            }
                            colorScheme='gray'
                        >
                            {item.label}
                        </Checkbox>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default React.memo(PatronOptions)
